import OfertaUpdate from './OfertaUpdate.vue'

export default OfertaUpdate

